import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';
import { Icon, SwIcon } from '@kaa/ui-flanders/components';

import { Banner } from './types';
import './styles.scss';
import { useBannerState } from './useBannerState';

interface Props {
  banner: Banner;
}

export const CommunicationBanner = ({ banner }: Props) => {
  const { i18n } = useTranslation();

  const { isDismissed, isActive, dismissBanner } = useBannerState(banner);

  const { messages, icon, textColor, backgroundColor, dismissible } = banner;

  const localizedMessage = useMemo(() => {
    return banner?.messages[i18n.language as keyof typeof messages];
  }, [messages, i18n.language]);

  if (isDismissed || !isActive || !localizedMessage) return null;

  const sanitizedMessage = DOMPurify.sanitize(localizedMessage);

  return (
    <div
      role="alert"
      className="communication-banner"
      style={{ color: textColor, backgroundColor }}
    >
      {icon && (
        <SwIcon icon={icon} modLarge className="communication-banner-icon" />
      )}

      <p
        className="communication-banner-message"
        dangerouslySetInnerHTML={{ __html: sanitizedMessage }}
      />

      {dismissible && (
        <button
          type="button"
          className="communication-banner-dismiss-button"
          onClick={dismissBanner}
        >
          <SwIcon icon={Icon.CLOSE} />
        </button>
      )}
    </div>
  );
};
